import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (onOpenModal, t) => [
    {
        label: t('discover.entity_clusters.table.name'),
        key: 'name',
        data: 'name',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong className="wrap-text">{data}</strong>;
        },
    },
    {
        label: t('discover.entity_clusters.table.wiki'),
        key: 'wiki',
        data: 'wiki',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong className="wrap-text">{data}</strong>;
        },
    },
    {
        label: t('discover.entity_clusters.table.relevancy'),
        key: 'relevancy',
        data: 'relevancy',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return numeral(data).format('0.0a');
        },
    },
    {
        label: t('discover.entity_clusters.table.pagesCNT'),
        key: 'pagesCNT',
        data: 'pagesCNT',
        Component: Cell,
    },
    {
        label: t('discover.entity_clusters.table.pages'),
        key: 'pages',
        data: 'pages',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="wrap-text d-flex align-items-center">
                    <div style={{ float: 'left', marginRight: '10px' }}>{data?.[0]}</div>
                    <div
                        className="link-website cursor-pointer d-flex align-items-center justify-content-center"
                        onClick={() => onOpenModal(data)}
                    >
                        <i className="icon-enlarge" style={{ fontSize: '12px' }}></i>
                    </div>
                </div>
            );
        },
    },
];

export const CHART_KEYS = [
    {
        key: 'relevancy',
        label: 'Relevancy',
        icon: 'ctr',
    },
];
